import { StyleSheet } from 'react-native';

/**
 * All sizing / colour tokens are derived from the theme that is passed in,
 * mirroring the pattern used across the rest of the app.
 */
export const listToolbarStyle = (theme: any) => {
    return StyleSheet.create({
        // ── outer row ────────────────────────────────────────────────────────
        container: {
            flexDirection: 'row',
            alignItems: 'center',
            marginHorizontal: 10,
            marginVertical: 13,
            gap: 8,
        },

        // ── search (flex: 1 so it fills remaining space) ─────────────────────
        searchWrapper: {
            flex: 1,
        },

        // ── icon buttons (filter / sort) ─────────────────────────────────────
        iconButton: {
            backgroundColor: theme.light,
            paddingVertical: 7,
            paddingHorizontal: 7,
            borderRadius: 7,
            borderColor: theme.light,
            borderWidth: 1,
            justifyContent: 'center',
            alignItems: 'center',
        },
        iconButtonActive: {
            // borderColor: theme.primary,
            backgroundColor: theme.light

        },

        // ── badge over filter icon ────────────────────────────────────────────
        filterBadge: {
            position: 'absolute',
            top: -4,
            right: -4,
            height: 18,
            minWidth: 18,
            borderRadius: 9999,
            backgroundColor: theme.secondary,
            justifyContent: 'center',
            alignItems: 'center',
            paddingHorizontal: 2,
        },

        // ── right cluster (location + add) ────────────────────────────────────
        rightCluster: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 8,
        },

        // ── location outline button ───────────────────────────────────────────
        locationButton: {
            borderRadius: 7,
            borderColor: theme.primary,
            paddingVertical: 8,
            paddingHorizontal: 10,
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4,
            borderWidth: 1,
        },
        locationButtonText: {
            fontSize: theme.smallFontSize,
            fontFamily: theme.bold,
            color: theme.dark,
        },

        // ── add filled button ─────────────────────────────────────────────────
        addButton: {
            borderRadius: 7,
            paddingVertical: 9,
            paddingHorizontal: 14,
            justifyContent: 'center',
            alignItems: 'center',
        }
    });
};

